module.exports = __webpack_public_path__ + "static/InterFaceThin-498e2452dbbbd4fb032d2fe43ed5ebd8.woff";